import { useState } from "react";
import {
  baseRouteMaker,
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useCustomerDetailsTabMenuUtils = () => {
  const [menuGroup, setMenuGroup] = useState(() => {
    const tempMenuGroup = [];

    /* menuItemDetails */
    const menuItemDetails = {
      id: "customer-details-details",
      title: t("Modules.Provider.details"),
      url: baseRouteMaker(routes.SERVICE_PROVIDER_CUSTOMER_INFO_DETAILS_DETAILS),
    };
    tempMenuGroup.push(menuItemDetails);
    /* menuItemDetails */

    /* menuItemAppointments */
    const menuItemAppointments = {
      id: "customer-appointments-details",
      title: t("Modules.Provider.appointments"),
      url: baseRouteMaker(routes.SERVICE_PROVIDER_CUSTOMER_INFO_DETAILS_APPOINTMENTS),
    };
    tempMenuGroup.push(menuItemAppointments);
    /* menuItemAppointments */

    return tempMenuGroup;
  });

  return menuGroup;
};
